import {BaseNumberModel} from '@shared/base/base-number-model';

export class Article extends BaseNumberModel {
  uuid: string | null;
  id: number;
  name: string;
  description: string;
  type: string;
  piecePrice: number;
  ledgerAccount: number;
  vatId: number;
  active: boolean;
}
